'use client';

import { Currency } from '../../constants';
import { useCartService } from './useCartService';

export const useProductAddToCart = ({ currency }: { currency: Currency }) => {
  const { useAddToCart } = useCartService();
  const { mutate: addToCart } = useAddToCart({ currency });

  const handleAddToCart = (sku: string, quantity = 1) => {
    addToCart({
      sku,
      quantity,
      currency,
    });
  };

  return {
    handleAddToCart,
  };
};
